module.exports = __webpack_public_path__ + "static/media/batteries-bulbs.659d5755.svg";